// extracted by mini-css-extract-plugin
export var contrastLow = "_t-1";
export var externalLink = "_t-2";
export var externalLinkIcon = "_t-3";
export var link = "_t-0";
export var linkLabel = "_t-4";